import React, { FC } from 'react';
import styled from 'styled-components';
import { focusStyle } from '../../styles/focusStyle';

const StyledLink = styled.a`
  font-size: 15px;
  line-height: ${({ theme }) => theme.lineHeights.xxs};
  color: ${({ theme }) => theme.colors.elvitaWebPurple};
  font-weight: 300;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    color: ${({ theme }) => theme.colors.elvitaWebPink};
    text-decoration: none;
  }
  ${focusStyle}
`;

type AnchorProps = {
  href: string;
  children: React.ReactNode;
};

const ExternalAnchor: FC<AnchorProps> = ({ href, children }) => {
  return <StyledLink href={href}>{children}</StyledLink>;
};

export default ExternalAnchor;
